import Vue from 'vue';
import Vuex from 'vuex'
import moduleA from './moduleA'

// 1.安装插件
Vue.use(Vuex)

// 2.创建对象
const store = new Vuex.Store({
  state:{
    // 显示加载中动画
    showLoading: false,
    // 显示toast
    showToast: false,
    toastMessage: "toast文字",
  },
  mutations:{
    // 切换加载中动画
    switchLoading(state, showOrHide){
      state.showLoading = showOrHide;
    },
    // 切换toast
    switchToast(state, payload){
      state.showToast = payload["showOrHide"];
      state.toastMessage = payload["toastMessage"];
    },
  },
  modules: {
    moduleA
  }
})

// 3.导出
export default store


// WEBPACK FOOTER //
// ./src/store/index.js